module.exports = __webpack_public_path__ + "5a2c197e38fd2b23ed59d85be061e482.png";